package game.controller

import com.soywiz.korev.Key
import com.soywiz.korge.input.Input
import game.CgaColor
import game.Game
import game.Language
import view.Terminal

val credits = mapOf(
    Language.English to arrayOf(
        "", // Filler
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "WISHLAIR",
        "--------",
        "",
        "A game by",
        "Chronogears",
        "",
        "Programming",
        "Jean-Fran\u0087ois Bilodeau",
        "Carlos Ballesteros Velasco (soywiz)",
        "",
        "Editing",
        "Jessica Torrance",
        "",
        "Music",
        "Misanther Roupe",
        "(www.fiverr.com/share/Pydr2g)",
        "",
        "Testers",
        "George & Ada-Marie Bilodeau",
        "Adam Misener",
        "",
        "Made with \u0003 with Korge",
        "https://korge.org/",
        "", // Filler
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
    ),
    Language.French to arrayOf(
        "WISHLAIR",
        "--------",
        "",
        "A game by",
        "Jean-Fran\u0087ois Bilodeau",
        "",
        "Programming",
        "J-F Bilodeau",
        "Carlos Ballesteros Velasco (soywiz)",
        "",
        "Editing",
        "Jessica Torrance",
        "",
        "Alpha Testers",
        "George & Ada-Marie Bilodeau",
        "",
        "Traduction Fran\u0087aise",
        "",
        "",
        "Testers",
        "",
        "",
        "Made with Korge",
        "https://korge.org/",
    )
)

class CreditsController(val showFather: Boolean = false) : GameController() {
    lateinit var scroll: TitleScroll
    var scrollCoolDown = 0
    var creditPos = 0
    var creditCoolDown = 0

    override fun onActivate(game: Game) {
        scroll = TitleScroll(game, 80)
    }

    override fun onTick(game: Game, input: Input) {
        if (scrollCoolDown > 0) {
            scrollCoolDown--
        } else {
            scroll.scrollRight()
            scrollCoolDown = 25
        }

        if (creditCoolDown > 0) {
            creditCoolDown--
        } else {
            creditPos++
            if (creditPos >= credits[game.settings.language]!!.size - 15) {
                creditPos = 0
            }
            creditCoolDown = 40
        }

        if (input.mouseButtons != 0 || input.keys[Key.ESCAPE] || input.keys[Key.SPACE]) {
            game.controller = TitleController()
        }
    }

    override fun onRender(game: Game, terminal: Terminal) {
        terminal.clear(CgaColor.BLACK)

        for (i in 0..14) {
            val fgColor = when (i) {
                0, 14 -> CgaColor.DARK_GRAY
                1, 13 -> CgaColor.LIGHT_GRAY
                else -> CgaColor.WHITE
            }
            val line = credits[game.settings.language]!![i + creditPos]
            terminal.drawStringCentered(0, i, 79, line, fgColor, CgaColor.BLACK)
//            terminal.drawString(0, i, line, fgColor, CgaColor.RED)
        }

        scroll.render(terminal, 0, 15)
        terminal.setChar(41, 21, 2, CgaColor.LIGHT_BLUE.rgba, terminal.getChar(41, 21).fgColor)
        if (showFather) {
            terminal.setChar(40, 21, 2, CgaColor.RED.rgba, terminal.getChar(4, 21).fgColor)
        }
    }
}